import { isFedRamp } from '@atlaskit/atlassian-context';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import TeamCentralCardClient from './TeamCentralCardClient';
import TeamProfileCardClient from './TeamProfileCardClient';
import UserProfileCardClient from './UserProfileCardClient';
class ProfileCardClient {
  constructor(config, clients) {
    this.userClient = (clients === null || clients === void 0 ? void 0 : clients.userClient) || new UserProfileCardClient(config);
    this.teamClient = (clients === null || clients === void 0 ? void 0 : clients.teamClient) || new TeamProfileCardClient(config);
    this.tcClient = maybeCreateTeamCentralClient(config, clients);
  }
  flushCache() {
    var _this$tcClient;
    this.userClient.flushCache();
    this.teamClient.flushCache();
    (_this$tcClient = this.tcClient) === null || _this$tcClient === void 0 ? void 0 : _this$tcClient.flushCache();
  }
  getProfile(cloudId, userId, analytics) {
    return this.userClient.getProfile(cloudId, userId, analytics);
  }
  getTeamProfile(teamId, orgId, analytics) {
    return this.teamClient.getProfile(teamId, orgId, analytics);
  }
  getReportingLines(userId) {
    var _this$tcClient2;
    return ((_this$tcClient2 = this.tcClient) === null || _this$tcClient2 === void 0 ? void 0 : _this$tcClient2.getReportingLines(userId)) || Promise.resolve({
      managers: [],
      reports: []
    });
  }
  getTeamCentralBaseUrl() {
    var _this$tcClient3;
    return (_this$tcClient3 = this.tcClient) === null || _this$tcClient3 === void 0 ? void 0 : _this$tcClient3.options.teamCentralBaseUrl;
  }
  shouldShowGiveKudos() {
    if (!this.tcClient || !this.getTeamCentralBaseUrl()) {
      return Promise.resolve(false);
    }
    return this.tcClient.checkWorkspaceExists();
  }
}
function maybeCreateTeamCentralClient(config, clients) {
  if (getBooleanFF('platform.profilecard-disable-team-central-client-in-fedramp_ilnm7')) {
    if (isFedRamp()) {
      return undefined;
    }
  }
  if (clients !== null && clients !== void 0 && clients.teamCentralClient) {
    return clients.teamCentralClient;
  }
  const teamCentralUrl = config.teamCentralUrl;
  return teamCentralUrl ? new TeamCentralCardClient({
    ...config,
    teamCentralUrl
  }) : undefined;
}
export default ProfileCardClient;